/* eslint-disable react/jsx-props-no-spreading */
import DOMPurify from 'dompurify';
import type { FC } from 'react';

import type { ProductInformationProps } from './ProductDetailsAccordion.types';

const ProductInformation: FC<React.PropsWithChildren<ProductInformationProps>> = (props) => {
    return (
        <>
            {props.isPharmaceutical && (
                <p className="u-marginTz u-marginBxsm">
                    <strong>För farmaceutisk rådgivning: Vänd dig till sjukvården</strong>
                </p>
            )}
            {props.description && (
                <div itemProp="description">
                    {DOMPurify.sanitize(props.description, {
                        USE_PROFILES: { html: false },
                    })}
                </div>
            )}
            {props.isMagazine && (
                <div>
                    <h5 className="u-marginTmd">Dagsaktuell tidning</h5>
                    <p className="u-marginTz">
                        När vi plockar din order väljer vi den dagsaktuella utgåvan. Notera att det
                        kan innebära en senare utgåva än den som är aktuell vid
                        beställningstillfället.
                    </p>
                </div>
            )}
        </>
    );
};

export default ProductInformation;
